import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Text, FontWeight } from 'components/Text';

const Container = styled.div`
  
  .profile-open{
    right: 0px;
  }
  .icon-menu{
    margin-right: 15px;
    display: none;
    margin-top: 3px;
    float: left;
  }
  @media (max-width: 1080px) {
    .icon-menu{
      display: inline-block;
    }
    .menu-open{
      left: 0px;
      box-shadow: 5px 0px 6px 1px rgba(179,174,174,0.17);
      .icon-close{
        left: 280px !important;
      }
    }
    .menu-close{
      left: -340px;
    }
  }
`;

export const Scrollbox = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
  padding: 10px 10px 50px 10px;
  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

const Main = styled.div`
  width: calc(100% - 350px);
  margin-left: 350px;
  height: 65vh;
  background: #fff;
  //box-shadow: -3px 7px 6px 1px rgba(179, 174, 174, 0.17);
  border-radius: 0px 0px 0px 40px;
  padding: 30px;
  
  @media (max-width: 1368px){
    height: 80vh;
  }
  @media (max-width: 1080px) {
    width: 100%;
    margin-left: 0px;
  }
  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const Title = styled(Text)`
  margin-top: 0px;
  font-size: 30px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.GRAY[6]};
  @media (max-width: 1200px) {
    font-size: 30px;
  }
  @media (max-width: 768px) {
    font-size: 22px;
  }
  @media (max-width: 499px) {
    font-size: 16px;
  }
`;

const Subtitle = styled(Text)`
  margin-top: 15px;
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  color: ${Colors.GRAY[6]};
  display: block;
`;

const User = styled.div`
  width: 250px;
  float: right;
  cursor: pointer;
  @media (max-width: 1098px) {
    width: 70px;
  }
  @media (max-width: 499px) {
    width: 50px;
  }
`;

const Photo = styled.div`
  width: 60px;
  height: 60px;
  background: #fff;
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  margin-top: -10px;
  padding-top: 10px;
  margin-right: 20px;
  float: left;
  margin-bottom: 30px;
  .icon-user-gray:before{
    background-size: contain;
    width: 38px;
    height: 32px;
    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 2px;
  }
  .icon-check-ok{
    margin-left: 40px;
    margin-top: -5px;
    float: right;
  }
  .icon-check-ok:before {
    background-size: contain;
    display: inline-block;
    width: 24px;
    height: 24px;
    content: "";
    border-radius: 20px;
  }
  @media (max-width: 499px) {
    width: 50px;
    height: 50px;
    .icon-user-gray:before{
      background-size: 30px 24px;
      width: 30px;
      height: 24px;
    }
    .icon-check-ok:before {
      width: 20px;
      height: 20px;
    }
  }
`;

const Name = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};
  @media (max-width: 1098px) {
    display: none;
  }
`;

const Country = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};
  @media (max-width: 1098px) {
    display: none;
  }
`;

const ContentProfile = styled.div`
  right: -340px;
  width: 340px;
  height:100vh;

  position: fixed;
  background: ${Colors.WHITE};
  box-shadow: -5px 0px 6px 1px rgba(179,174,174,0.17);
  z-index: 10;
  top: 0px;

  transition: all 0.5s ease;
  overflow-y: auto;
  overflow-x: hidden;

  .icon-close{
    z-index: 100;
    margin: 10px 15px;
    position: absolute;
    font-size: 24px;
    cursor: pointer;
    float: left;
  }
`;

const ContentMenu = styled.div`
  transition: all 0.5s ease;
  background: ${Colors.WHITE};
  z-index: 900;
  position: fixed;
  height:100vh;
  overflow-y: auto;
  min-height: calc(100vh - 70px);
  .icon-close{
    z-index: 100;
    margin: 10px 15px;
    font-size: 30px;
    cursor: pointer;
    float: left;
    left: -50px;
    position: absolute;
  }
`;

const IconNotification = styled.div`
  background: red;
  height: 22px;
  width: 22px;
  margin-left: 35px;
  color: #fff;
  border-radius: 11px;
  text-align: center;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  @media (max-width: 499px) {
    font-size: 14px;
  }
`;

export { Container, Main, Title, Subtitle, User, Photo, Name, Country, ContentProfile, ContentMenu, IconNotification };
